"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconSort = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M0,12 L6,12 L6,10 L0,10 L0,12 Z M0,0 L0,2 L18,2 L18,0 L0,0 Z M0,7 L12,7 L12,5 L0,5 L0,7 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconSort')(IconSort);